import clientActions from 'modules/clients/actions/actionTypes';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  todayRemindersAmount: 0,
  items: [],
  isLoading: false,
  reminderDetails: {},
};

const getUpdatedRemindersList = (remindersList, { id, payload }) =>
  remindersList.map((reminder) => {
    if (reminder.id === id) {
      return {
        ...reminder,
        ...payload,
      };
    }
    return reminder;
  });

const remindersReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.ASSOCIATE_REMINDERS_SUCCESS:
      return {
        ...state,
        items: payload,
        isLoading: false,
      };
    case actionTypes.ASSOCIATE_REMINDERS_LOADING:
    case clientActions.CREATE_CLIENT_REMINDER_LOADING:
    case clientActions.DELETE_CLIENT_REMINDER_LOADING:
    case clientActions.UPDATE_CLIENT_REMINDER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.ASSOCIATE_REMINDER_UPDATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        items: getUpdatedRemindersList(state.items, payload),
      };
    }
    case actionTypes.ASSOCIATE_REMINDERS_COUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        todayRemindersAmount: payload,
      };
    }
    case clientActions.GET_CLIENT_REMINDER_LOADING: {
      return {
        ...state,
        isLoading: true,
        reminderDetails: {},
      };
    }
    case clientActions.GET_CLIENT_REMINDER_SUCCESS: {
      return {
        ...state,
        reminderDetails: payload,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};

export default remindersReducer;
